<script>
import axios from 'axios';
import {BrandsPath} from '@/path.js';
import Swal from 'sweetalert2';
import { PackagingPath } from '../../../../path';

    export default {
        props : ['selectedPackaging'],
        data(){
            return {
                base_url : process.env.VUE_APP_API_BACKEND_URL,
                base_node_url: process.env.VUE_APP_API_BACKEND_NODE_URL,
                brands : [],
                filter : [],
                fields : ["name","Actions"],
                currentPage : 1,
                selectedBrands : []
            }
        },
        watch : {
            currentPage(){
                this.getBrands();
            }
        },
        methods : {
            async getBrands(){
                try {
                    let response = await axios.get(this.base_url + BrandsPath.BASIC_BRAND,{
                        params :{
                            page : this.currentPage
                        }
                    });
                    if(response.data.status == true){
                        this.brands = response.data.data;
                    }
                }catch (e){
                    console.log(e);
                }
            },
            async addBrand(v){
                try {
                    let res = await axios.post(this.base_node_url + PackagingPath.PACKAGING_BRAND_SAVE,{
                        packaging_id : this.selectedPackaging.id,
                        brand_id : v.id
                    });
                    if(res.data.status){
                        Swal.fire("added successfully","","success");
                        this.selectedBrands.push(v.id);
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async removeBrand(v){
                try {
                    let res = await axios.put(this.base_node_url + PackagingPath.PACKAGING_BRAND_REMOVE,{
                        packaging_id : this.selectedPackaging.id,
                        brand_id : v.id
                    });
                    if(res.data.status){
                        Swal.fire("removed successfully","","success");
                        this.selectedBrands = this.selectedBrands.filter(f => f != v.id);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },
        mounted() {
            this.selectedBrands = this.selectedPackaging.packaging_brand && this.selectedPackaging.packaging_brand.length > 0 ? this.selectedPackaging.packaging_brand.map(m => m.brand_id) : [];
            this.getBrands();
        }
    }
</script>

<template>
    <div>
        <b-table
                  :key="brands.key"
                  :items="brands.data"
                  :fields="fields"
                  responsive="sm"
                  :filter="filter"
                  :current-page="currentPage"
              >
              <template v-slot:cell(actions)="row">
                    <b-button variant="success" v-if="selectedBrands.filter(f => f == row.item.id).length == 0" @click="addBrand(row.item)">+</b-button>
                    <b-button variant="danger" v-else @click="removeBrand(row.item)">-</b-button>
              </template>
        </b-table>
        <div class="row">
            <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination :key="brands.key" v-model="currentPage" :total-rows="brands.total" :per-page="brands.per_page"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
    </div>
</template>

<style>
    
</style>